import styled from 'styled-components';

export const MultipleSelectFieldWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  width: 100%;
  flex-wrap: wrap;
`;

export const MultipleSelectFieldItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MultipleSelectFieldItem = styled.div`
  align-items: center;
  width: 280px;
  display: flex;
  max-width: 300px;

  & > div:first-child {
    width: 100%;
  }
`;

export const MultipleSelectFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;
`;

export const MultipleSelectFieldLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
`;

export const AddMoreSelectFieldButton = styled.div`
  font-size: 14px;
  font-weight: 500;
  width: fit-content;
  cursor: pointer;
`;

export const SelectFieldDeleteIcon = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: 20px;
  margin-left: 8px;
  margin-right: 12px;
`;
